import { render, staticRenderFns } from "./SubTaskTable.vue?vue&type=template&id=0a2a264a&scoped=true&"
import script from "./SubTaskTable.vue?vue&type=script&lang=js&"
export * from "./SubTaskTable.vue?vue&type=script&lang=js&"
import style0 from "./SubTaskTable.vue?vue&type=style&index=0&id=0a2a264a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2a264a",
  null
  
)

export default component.exports